module.exports = "<div>\r\n    {{message}}\r\n</div>"